import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListUserComponent } from './list-user/list-user.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { UpdateUserComponent } from './update-user/update-user.component';
import { permissionGuard } from 'src/app/shared/guards/permission/permission.guard';
import { Permission } from 'src/app/shared/models/permission/permission-dto';

const routes: Routes = [
  {
    path: '',
    canActivate: [permissionGuard],
    data: { permission: Permission.LIST_USER },
    component: ListUserComponent
  },
  {
    path: 'create',
    canActivate: [permissionGuard],
    data: { permission: Permission.CREATE_USER },
    component: CreateUserComponent
  },
  {
    path: ':id/update',
    canActivate: [permissionGuard],
    data: { permission: Permission.UPDATE_USER },
    component: UpdateUserComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule {}
